import type { SearchAppConfig } from '../models/SearchModels';

export function readSearchAppConfig(element: HTMLElement): SearchAppConfig {
  return {
    modulePath: element.dataset.modulePath || '/DesktopModules/Cengage_SearchEngine',
    staticUrl: element.dataset.staticUrl || '',
    isB2BUser: element.dataset.isB2bUser === 'true',
    recaptchaSiteKey: element.dataset.recaptchaSiteKey || '',
    listAction: element.dataset.listAction || '',
    signupUrl: element.dataset.signupUrl || '/signup.aspx'
  };
}
